var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSingle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 23.3301H28",
    stroke: "#4E575E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9996 10.0004C27.9843 9.20958 27.6633 8.45541 27.104 7.8961C26.5447 7.33679 25.7905 7.01578 24.9996 7.00042C24.5972 6.99366 24.1976 7.06793 23.8245 7.21881C23.4514 7.36969 23.1125 7.5941 22.8279 7.87868C22.5433 8.16326 22.3189 8.50218 22.168 8.87528C22.0171 9.24838 21.9429 9.64803 21.9496 10.0504V14.6104C21.9429 15.0128 22.0171 15.4125 22.168 15.7856C22.3189 16.1587 22.5433 16.4976 22.8279 16.7822C23.1125 17.0667 23.4514 17.2912 23.8245 17.442C24.1976 17.5929 24.5972 17.6672 24.9996 17.6604V17.6604C25.799 17.6447 26.5605 17.3168 27.1212 16.7468C27.6819 16.1768 27.9972 15.41 27.9996 14.6104",
    stroke: "#4E575E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6602 11.62H15.8102C16.5581 11.62 17.2753 11.9171 17.8042 12.446C18.333 12.9748 18.6302 13.6921 18.6302 14.44V14.88C18.6302 15.2503 18.5572 15.617 18.4155 15.9592C18.2738 16.3013 18.0661 16.6122 17.8042 16.874C17.5423 17.1359 17.2315 17.3436 16.8893 17.4853C16.5472 17.6271 16.1805 17.7 15.8102 17.7H12.6602V7H15.3202C15.879 7.00263 16.4141 7.22578 16.8092 7.62091C17.2044 8.01604 17.4275 8.5512 17.4302 9.11V9.44C17.4302 10.0005 17.2082 10.5383 16.8128 10.9355C16.4173 11.3328 15.8807 11.5574 15.3202 11.56H12.6602",
    stroke: "#4E575E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2 17.6705L5.38 7.06055L9.21 17.6705",
    stroke: "#4E575E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.58008 13.8301H7.26008",
    stroke: "#4E575E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingle);
export default __webpack_public_path__ + "static/media/Single.56d78078c84cc59f07d221ca3403ff18.svg";
export { ForwardRef as ReactComponent };